import React from 'react';

import { ReactComponent as CheckBoxActiveIcon } from '../../assets/icons/check-box-active-icon.svg';
import { ReactComponent as CheckBoxIcon } from '../../assets/icons/check-box-icon.svg';

interface CustomCheckInputProperties {
  inputLabel?: string;
  checkboxLabel: string;
  value: boolean;
  name: string;
  onChangeValue: (name: string, value: boolean) => void;
  valueRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Check box buttons function component
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.checkboxLabel - The checkboxLabel prop
 * @param {any} param0.name - The name prop
 * @param {any} param0.value - The value prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.error - The error prop
 * @param {any} param0.errorMessage - The errorMessage prop
 * @param {any} param0.fontSize - The fontSize prop
 */
function CustomCheckbox({
  inputLabel,
  checkboxLabel,
  name,
  value,
  onChangeValue,
  valueRequired,
  error,
  errorMessage,
  fontSize,
}: CustomCheckInputProperties) {
  return (
    <div className={`custom-checkbox-wrap ${fontSize}`}>
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div
        className="custom-checkbox-container"
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
          onChangeValue(name, !value);
        }}
        role="presentation">
        <div className="checkbox-icon">{value ? <CheckBoxActiveIcon /> : <CheckBoxIcon />}</div>
        <div className="checkbox-label">{checkboxLabel}</div>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomCheckbox.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  error: false,
  errorMessage: '',
  fontSize: 'small',
};

export default React.memo(CustomCheckbox);
